import {ControlledDatepicker, ControlledDatepickerValue, Tab, TabsPanel, ControlledInput} from '@hm/fundamental'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {CategoryTypes, DocumentsTableFilter} from './Documents.types'

type DocumentsFiltersProps = {
  filter: DocumentsTableFilter
  setFilter: (filter: DocumentsTableFilter) => void
  hasMultipleCustomers: boolean
  selectedCustomerId: string
  onCustomerIdChange: (customerId: string) => void
}

export const DocumentsFilters = ({
  filter,
  setFilter,
  hasMultipleCustomers,
  selectedCustomerId,
  onCustomerIdChange
}: DocumentsFiltersProps) => {
  const {t} = useTranslation()

  const [dateRange, setDateRange] = useState<ControlledDatepickerValue>([null, null])

  useEffect(() => {
    setFilter({
      ...filter,
      createdOnFrom: dateRange?.[0]?.toLocaleDateString(),
      createdOnTo: dateRange?.[1]?.toLocaleDateString()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange])

  const ensureDateRangeTuple = (val: ControlledDatepickerValue): [Date | null, Date | null] => {
    if (Array.isArray(val) && val.length === 2) return [val[0], val[1]]
    return [null, null]
  }

  const handleCreatedAtChange = (value: ControlledDatepickerValue) => {
    setDateRange(ensureDateRangeTuple(value))
  }

  const handleDocumentTypeChange = (value: string) => {
    setFilter({...filter, hubCategory: value})
  }

  const formatTabPanelItem = (category: CategoryTypes) => {
    return `text-white hover:text-gray-300 ${
      filter.hubCategory === category && 'after:bg-white hover:text-gray-300 hover:after:bg-gray-300'
    }`
  }

  return (
    <div className="flex gap-4 justify-center px-6 mb-4">
      {hasMultipleCustomers && (
        <ControlledInput
          label={t('sharePointDocuments.filters.customerId')}
          value={selectedCustomerId}
          onChange={(event) => onCustomerIdChange(event.target.value)}
          className="bg-white"
        />
      )}
      <ControlledDatepicker
        name="document-creation-date-range"
        label={t('sharePointDocuments.filters.datePicker')}
        value={ensureDateRangeTuple(dateRange)}
        onChange={(value) => handleCreatedAtChange(value)}
      />
      <TabsPanel onSelect={(value) => handleDocumentTypeChange(value)}>
        <Tab
          label={t('sharePointDocuments.filters.categories.all')}
          value={CategoryTypes.ALL}
          className={formatTabPanelItem(CategoryTypes.ALL)}
        />
        <Tab
          label={t('sharePointDocuments.filters.categories.common')}
          value={CategoryTypes.COMMON}
          className={formatTabPanelItem(CategoryTypes.COMMON)}
        />
        <Tab
          label={t('sharePointDocuments.filters.categories.finance')}
          value={CategoryTypes.FINANCE}
          className={formatTabPanelItem(CategoryTypes.FINANCE)}
        />
        <Tab
          label={t('sharePointDocuments.filters.categories.qualityAssurance')}
          value={CategoryTypes.QUALITY_ASSURANCE}
          className={formatTabPanelItem(CategoryTypes.QUALITY_ASSURANCE)}
        />
      </TabsPanel>
    </div>
  )
}
